import { render, staticRenderFns } from "./CarrosView.vue?vue&type=template&id=65a166e3&"
import script from "./CarrosView.vue?vue&type=script&lang=ts&"
export * from "./CarrosView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports